import { useDraggable } from '@dnd-kit/core';
import { PseudoEntity } from '@data/entity/types';
import { TagBadge } from '@components/tag/TagBadge';

import { createDraggableId, DraggableType, DraggableInfo, DragSourceType } from '@data/dragAndDrop/types';

export type TagsDraggableProps = {
    entity: PseudoEntity;
};

export const TagsDraggable = (props: TagsDraggableProps) => {
    const { entity } = props;

    const draggableInfo: DraggableInfo = {
        type: DraggableType.Tag,
        tagId: entity.id,
        tagType: entity.type,
        tagPropertyId: entity.key as number | undefined,
        label: entity.meta?.name ?? '',
        sourceInfo: { type: DragSourceType.TagSidebar },
    };
    const draggableId = createDraggableId({ ...draggableInfo });

    const { attributes, listeners, setNodeRef } = useDraggable({
        id: draggableId,
        data: { ...draggableInfo },
    });

    return (
        <div {...attributes} {...listeners} ref={setNodeRef} style={{ cursor: 'grab' }}>
            <TagBadge type={entity.type} label={draggableInfo.label} typeIcon />
        </div>
    );
};
